import { render, staticRenderFns } from "./PendingReceiveList.vue?vue&type=template&id=0e01d518"
import script from "./PendingReceiveList.vue?vue&type=script&lang=js"
export * from "./PendingReceiveList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e01d518')) {
      api.createRecord('0e01d518', component.options)
    } else {
      api.reload('0e01d518', component.options)
    }
    module.hot.accept("./PendingReceiveList.vue?vue&type=template&id=0e01d518", function () {
      api.rerender('0e01d518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/purchase/pending-receive/components/PendingReceiveList.vue"
export default component.exports